import { render, staticRenderFns } from "./RankingVentasCliente.vue?vue&type=template&id=760d20da&"
import script from "./RankingVentasCliente.vue?vue&type=script&lang=js&"
export * from "./RankingVentasCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports